import { z } from "zod";

import { eventTypeAppCardZod } from "../eventTypeAppCardZod";

const paymentOptionSchema = z.object({
  label: z.string(),
  value: z.string(),
});
export const paymentOptionsSchema = z.array(paymentOptionSchema);

export const paymentOptions = [
  {
    label: "on_booking_option",
    value: "ON_BOOKING",
  },
];

type PaymentOption = (typeof paymentOptions)[number]["value"];
const VALUES: [PaymentOption, ...PaymentOption[]] = [
  paymentOptions[0].value,
  ...paymentOptions.slice(1).map((option) => option.value),
];
export const paymentOptionEnum = z.enum(VALUES);

export const appDataSchema = eventTypeAppCardZod.merge(
  z.object({
    MC_URL: z.string().optional().default("https://api.test.maksekeskus.ee"),
    price: z.number(),
    currency: z.string().default("EUR"),
    paymentOption: z.string().optional(),
    enabled: z.boolean().optional(),
  })
);

export const appKeysSchema = z.object({
  store_id: z.string().min(1),
  api_secret_key: z.string().min(1),
  api_public_key: z.string().min(1),
});
